import Link from 'next/link';
import { useEffect, useState } from "react";
import http from "utilities/http";
import { useCart } from "framework/store";
import isEmpty from 'lodash/isEmpty';
import {ProductSchema} from "../../schemas/ProductSchema";

const sortBreadCrumbByLevel = (a, b) => {
    return a.level - b.level > 0 ? 1 : -1;
};

export default function Category({ product, type }) {
    const [item, setItem] = useState([]);
    const [stateStore, actions] = useCart();
    const categoriesStore = stateStore.categories;

    const fetchAll = async () => {
        let categories = categoriesStore;
        let breadCrumbUrl = '/shop/';

        if (isEmpty(categories)) {
            const categoriesParams = {
                filters: [[{
                    field: 'level',
                    value: '0',
                    condition_type: 'gt'
                }]],
                size: 0,
            };
            const res = await http('/rest/V1/categories/list', categoriesParams, { token: 'default' });
            categories = res.items;
            actions.setCategoriesShop(categories);
        }
        const category_links = (product.extension_attributes?.category_links || []).filter(x => x.category_id != 1);
        const categoryLink = category_links;
        const breadCrumb = categories
            .filter((ct) =>
                categoryLink.some((ct2) => ct2.category_id == ct.id) && ct.level > 1
            )
            .sort(sortBreadCrumbByLevel)
            .map((category) => {
                breadCrumbUrl =
                    breadCrumbUrl +
                    category.custom_attributes.find(
                        (x) => x.attribute_code === "url_key"
                    )?.value +
                    "/";
                return {
                    name: category.name,
                    url: breadCrumbUrl,
                    level: category.level,
                };
            });
        setItem(breadCrumb);
    };

    useEffect(() => {
        fetchAll();
    }, []);
    const schema = new ProductSchema(product);
    const renderSchema = schema.BreadcrumbList(item);
    return (
        <div className={type === 'line' ? 'breadcrumbList p-0' : 'breadcrumbList'}>
            <ul className={type === 'line' ? 'ctg-list' : 'ctg-list-2'}>
                {item
                    ? item.map((x, index) =>
                        (<li key={index}>
                            <Link href={x.url}>
                                <a>{x.name}</a>
                            </Link>
                        </li>))
                    : <li key={0}></li>
                }
            </ul>
            <script type="application/ld+json" key="breadCrumb" dangerouslySetInnerHTML={{__html: JSON.stringify(renderSchema)}}></script>
        </div>
    );
};